<i18n>
{
  "en": {
    "serviceCharge": "Service charge {serviceCharge}%",
    "discount": "Discount {discount}% off",
    "price": "$ {price}",
    "total": "Total:"
  },
  "zh-tw": {
    "serviceCharge": "服務費 {serviceCharge}%",
    "discount": "優惠折扣 {discount}%",
    "price": "{price} 元",
    "total": "總計:"
  }
}
</i18n>

<template>
  <div v-if="menu">
    <div v-for="(reducedItemObj, index) in reducedItemObjs" :key="`order-details-${index}`">
      <div>
        <span>{{ reducedItemObj.item.title }} (${{ reducedItemObj.item.price }}) x {{ reducedItemObj.amount }}</span>
        <span style="float: right;">{{ reducedItemObj.item.totalPrice * reducedItemObj.amount }} 元</span>
      </div>
      <div v-for="(detail, index) in itemPriceDetails(reducedItemObj.item)" :key="`order-details-item-detail-${index}`" style="font-size: 12px; color: #212121;">
        - {{ detail }}
      </div>
    </div>
    <div v-if="order.serviceCharge !== 0">
      <span>{{ $t(`serviceCharge`, { serviceCharge: order.serviceCharge }) }}</span>
      <span style="float: right;">{{ $t(`price`, { price: servicePrice }) }}</span>
    </div>
    <div v-if="order.discount.val > 0">
      <span>{{ $t(`discount`, { discount: order.discount.val }) }}</span>
      <span style="float: right;">{{ $t(`price`, { price: discountAmount }) }}</span>
    </div>
    <hr>
    <span>{{ $t(`total`) }}</span>
    <span style="float: right;">{{ $t(`price`, { price: parseFloat(order.totalPrice) }) }}</span>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'OrderDetails',
  dependencies: [
    'CartElementBuilder'
  ],
  props: {
    order: Object,
    menu: Object
  },
  created () {
    if (this.storeId) {
      this.downloadMenu({
        version: this.order.menuVersion,
        variation: this.order.menuVariation
      })
    }
  },
  computed: {
    ...mapGetters(['storeId']),
    ...mapGetters('itemModule', ['discountAmount']),
    reducedItemObjs () {
      return this.order.data.items
        .map(obj => this.CartElementBuilder.buildItem(obj, this.menu))
        .reduce((items, item) => {
          const target = items.find(i => i.item.equalsToItem(item))
          if (target === undefined) {
            return items.concat([{
              amount: 1,
              item: item
            }])
          }
          target.amount = target.amount ? target.amount + 1 : 1
          return items
        }, [])
    },
    subtotal () {
      return this.order.data.items
        .map(obj => this.CartElementBuilder.buildItem(obj, this.menu))
        .reduce((totalPrice, item) => totalPrice + item.totalPrice, 0)
    },
    servicePrice () { // 服務費
      return parseFloat((this.subtotal * ((this.order.serviceCharge / 100))).toFixed(2))
    }
  },
  watch: {
    storeId (v) {
      if (!this.menu) {
        this.downloadMenu({
          version: this.order.menuVersion,
          variation: this.order.menuVariation
        })
      }
    }
  },
  methods: {
    ...mapActions('menuModule', ['downloadMenu']),
    itemPriceDetails (item) {
      return item.questions
        ? item.questions.filter(q =>
          q.totalPrice !== 0 || q.alwaysDisplay || !q.isValueDefault
        ).map(q =>
          q.valueString +
          (q.totalPrice === 0 ? '' : ' ($' + q.totalPrice + ')'))
        : []
    }
  }
}
</script>
